import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21",
  fill: "none",
  viewBox: "0 0 20 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" clip-path=\"url(#a)\"><path d=\"M15.625 5.914a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m0-2.5v-.937M14.546 4.04l-.812-.47m.812 1.72-.812.468m1.891.156v.938M16.71 5.29l.813.468M16.71 4.04l.813-.47M10 12.79a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25\"></path><path d=\"M4.984 15.866a5.625 5.625 0 0 1 10.032 0\"></path><path d=\"M17.4 9.04a7.493 7.493 0 1 1-6.147-6.147\"></path></g><defs><clipPath id=\"a\"><path fill=\"currentColor\" d=\"M0 .29h20v20H0z\"></path></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }